<template>
  <div class="wrapper-element-bottom d--grid">
    <div
      ><el-link type="info" @click="handleClear">{{
        $t('general.clear')
      }}</el-link></div
    >
    <div
      ><el-link type="success" @click="handleApply">{{
        $t('general.apply')
      }}</el-link></div
    >
  </div>
</template>

<script>
export default {
  name: 'LadFilterButtons',
  methods: {
    handleApply() {
      this.$emit('apply')
    },
    handleClear() {
      this.$emit('clear')
    },
  },
}
</script>

<style lang="scss">
.wrapper-element-bottom {
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-top: 15px;

  & > div {
    &:last-child {
      text-align: right;
    }
  }

  .el-link {
    display: inline-block;
  }
}
</style>
